<template>
  <div class="box_header_hotline">
    <div class="col-md-12">
      <div class="group_level_1">
        <span class="title_hotline" >Tổng đài trợ giúp:</span>
        <div class="box_phone">
          <div class="group_level_2">
            <img class="ic_hotline" src="../../../public/assets/images/phone_ic.png">
            <span class="text_hotline">1900636536</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        props: {
            lstData: Array
        },
        data() {
            return {
                message: ''
            }
        },
        mounted () {
        },
        methods: {
        },
    }
</script>

<style lang="scss">
.box_header_hotline{
  padding: 30px 37.5px 0px 37.5px;
  @media (max-width: 575px) {
    padding: 30px 5px 0px 5px;
  }
  .group_level_1{
    height: 33px;position: relative;width: 100%;
    .title_hotline{
      text-align:right;position: absolute;top: 0; bottom: 0; left: 0; right: 165px; margin: auto;height: fit-content; font-style: normal; font-weight: 600; font-size: 14px;color: #000000;
    }
    .box_phone{
      position: absolute;right:0px;height: 33px;width: 157px;background: #FFFFFF;border: 1px solid #EC1E2B; box-sizing: border-box; border-radius: 100px;
      .group_level_2{
        position: relative;width: 100%;height: 33px;
        .ic_hotline{
          width: 15px;height: 15px; position: absolute;top: 0; bottom: 0; left: 18.5px; right: 0; margin-bottom: auto; margin-top: auto;
        }
        .text_hotline{
          height: fit-content;position: absolute;top: 0; bottom: 0; left: 44px; right: 0; margin-bottom: auto; margin-top: auto; font-style: normal; font-weight: 600; font-size: 17px;color: #EC1E2B;
        }
      }
    }
  }
}
</style>